import { contactEmail, siteName } from "@/mocks/works";
import SectionHeading from "./SectionHeading";

const principles = [
  { icon: "ri-thumb-up-line", title: "口碑优先", desc: "只推荐真正经得起同好检验的作品，不掺水、不堆量。" },
  { icon: "ri-refresh-line", title: "持续更新", desc: "榜单与推荐随讨论热度动态校正，每期都有新鲜内容。" },
  { icon: "ri-eye-line", title: "客观真实", desc: "评分与评价来自真实同好反馈，信息透明可查。" },
  { icon: "ri-shield-check-line", title: "尊重版权", desc: "平台仅做推荐与介绍，版权归原版权方所有。" },
];

const milestones = [
  { year: "2022", text: "建立首批同好交流社群，开始整理口碑作品清单。" },
  { year: "2023", text: "上线专题盘点与分类体系，内容维度更丰富。" },
  { year: "2025", text: "开放同好评价板块，评分体系动态化。" },
  { year: "2026", text: "迭代至人气排行与口碑精选双引擎，服务更多同好。" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-start">
          <div>
            <SectionHeading
              align="left"
              eyebrow="关于我们"
              title={`${siteName}，为同好而生的人妻动漫内容精选站`}
            />
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              <p>
                我们是一群热爱人妻动漫题材的普通同好。做这个站点的初衷很简单：这个题材的作品五花八门，
                质量参差不齐，想找一部值得看的作品，常常要在评分、讨论和推荐之间反复折腾，非常耗时。
              </p>
              <p>
                于是我们把同好的评价、口碑与讨论热度汇聚起来，用推荐、盘点与排行榜的方式，把好作品精选出来。
                我们不做夸张的标题党，也不做无脑的堆量，只把真正打动人的内容诚实地呈现给你。
              </p>
              <p>
                从题材分类到口碑榜，从入坑指南到年度盘点，我们希望这里能成为你安心、省心、看得开心的内容栖息地。
              </p>
            </div>

            <h3 className="mt-8 font-heading text-lg font-bold text-foreground-900">内容原则</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3 rounded-xl bg-background-100 p-4 ring-1 ring-background-200/70">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{p.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-900">发展历程</h3>
            <div className="mt-4 space-y-0">
              {milestones.map((m, idx) => (
                <div key={m.year} className="relative flex gap-4 pb-6">
                  {idx < milestones.length - 1 && (
                    <span className="absolute left-[11px] top-7 h-full w-px bg-background-200"></span>
                  )}
                  <span className="relative mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 ring-4 ring-primary-100">
                    <span className="h-2 w-2 rounded-full bg-background-50"></span>
                  </span>
                  <div>
                    <p className="font-heading text-base font-bold text-primary-600">{m.year}</p>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{m.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-2 rounded-2xl bg-primary-100/70 p-6 ring-1 ring-primary-200/60">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
                <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
                联系我们
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                有想推荐的作品、希望收录的专题，或发现任何信息需要更正？欢迎随时通过邮箱与我们交流，我们会认真阅读每一条建议。
              </p>
              <a
                href={`mailto:${contactEmail}`}
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
              >
                {contactEmail}
                <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}